// import the fingerprintjs opensource library
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getFingerprintData = () => {
    return new Promise((resolve, reject) => {
        // Get the visitor identifier when you need it.
        FingerprintJS
            .load()
            .then(fp => fp.get())
            .then(({ visitorId }) => {
                // This is the visitor identifier:
                resolve(visitorId)
            })
            .catch(() => {
                console.error('FP Error.');
                reject();
            })
    })
}